export class Widget {
}

export class ResponseWSWidget {
  success!: boolean;
  data: any;
}
